import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = () => {
  const { user, authLoading, profile } = useAuth();

  if (authLoading) {
    return <div style={{ padding: 20 }}>Loading…</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (user.email && user.emailVerified === false) {
    return <Navigate to="/" replace />;
  }

  // Uploader-only users should only see /upload — redirect them there
  if (profile?.role === 'uploader') {
    return <Navigate to="/upload" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
